import Axios from '../lib/axios'

class AppointmentService {
  async all (patientId) {
    const result = await Axios.authenticated().get(`/appointments/${patientId}`, {})
    return result
  }

  async create (appointment) {
    const result = await Axios.authenticated().post(
      `/appointments/${appointment.patientId}`,
      appointment
    )
    return result
  }

  async update (appointment) {
    const result = await Axios.authenticated().put(
      `/appointments/${appointment.patientId}`,
      appointment
    )
    return result
  }

  async updatePeriodic (appointment) {
    const result = await Axios.authenticated().put(
      `/appointments/${appointment.patientId}?periodic=true`,
      appointment
    )
    return result
  }

  async delete (appointment) {
    const result = await Axios.authenticated().delete(`/appointments/${appointment.patientId}`, { data: { id: appointment._id } })
    return result
  }

  async deletePeriodic (appointment) {
    const result = await Axios.authenticated().delete(`/appointments/${appointment.patientId}?periodic=true`, { data: { id: appointment._id } })
    return result
  }

  async toBeNotified (patientId) {
    const result = await Axios.authenticated().get(`/appointments/${patientId}/toBeNotified`)
    return result
  }
}

export default new AppointmentService()
